import React from "react";
import Label from "./Label";

const RadioGroup = ({
  id = "r-groups",
  title,
  description,
  options,
  onChange,
  currentValue,
  horizontal,
  labelClasses = "",
  wrap=true,
  disabled=false,
  inline=false,
}) => {
  if (!options || !options.length) {
    throw new Error("missing options");
  }

  const containerCls = horizontal
    ? `${wrap ? "flex-wrap" : ""} gap-x-5 -mx-4`
    : "flex-col space-y-4"

  return (
    <div className={
      `mb-1 flex 
      ${inline ? 'w-full flex-row items-center justify-between gap-4 pr-5' : 'flex-col'} 
      ${disabled ? "opacity-30 cursor-not-allowed" : ""}`
    }>
      <div>
        {title ? (
          <Label
            className={`text-base font-medium text-black-500 ${labelClasses}`}
          >
            {title}
          </Label>
        ) : null}
        {description ? (
          <p className="text-sm leading-5 text-gray-500">{description}</p>
        ) : null}
      </div>
      <fieldset className="mt-2" id={id} disabled={disabled}>
        <div
          className={`mt-1 flex ${containerCls}`}
        >
          {options.map(({ name, value, description }) => (
            <div
              onClick={() => {
                if (disabled) return;
                onChange(value);
              }}
              key={value}
              className={`relative flex items-start ${disabled ? "cursor-not-allowed" : "cursor-pointer"} ${horizontal ? "mb-2 ml-4" : ""}`}
            >
              <input
                name={id}
                readOnly
                id={value}
                type="radio"
                checked={currentValue === value}
                className={`focus:ring-am-500 h-4 w-4 ${disabled ? "cursor-not-allowed" : "cursor-pointer"} text-black-500 border-gray-300`}
                style={{marginTop: "0.25em"}}
                disabled={disabled}
              />
              <label
                htmlFor={value}
                className={`ml-3 block text-sm font-medium ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
              >
                {name}
                {!!description && (
                  <p className="font-normal mt-1 text-xs text-gray-4  00">
                    {description}
                  </p>
                )}
              </label>
            </div>
          ))}
        </div>
      </fieldset>
    </div>
  );
};

export default RadioGroup;
